import React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import FormControl from 'components/Forms/FormControl';
import { Form, Input, Button, Row, Col, Icon, notification, Tooltip } from 'antd';
import { EmailConfirmationHandler } from './EmailConfirmationHandler';
import { RouteComponentProps, withRouter } from 'react-router';
import { Redirect, NavLink } from 'react-router-dom';
import { ErrorResultModel } from 'Core/Api/UserManagement/Api';
import { InputColLayout, ButtonColLayout, StyleEmailConfirmationForm, InputLayout } from './EmailConfirmation.Stlye';
import ValidationUtility from 'Core/ValidationUtility';
import NotificationUtility from 'Core/NotificationUtility';

export interface Props extends RouteComponentProps, FormComponentProps {
  children?: React.ReactNode;
}

export interface State { }

class EmailConfirmationFormWithoutFormAndRouter extends React.Component<Props, State> {
  emailConfirmationHandler: EmailConfirmationHandler;

  constructor(props: Props) {
    super(props);
    this.emailConfirmationHandler = new EmailConfirmationHandler(props);
    this.state = {};
  }

  handleResendCode = (e: React.FormEvent) => {
    e.preventDefault();

    this.props.form.validateFields(['username'], (errors, value) => {
      if (!errors) {
        this.emailConfirmationHandler
          .ResendConfirmationCode(value.username)
          .then(() => {
            NotificationUtility.success(
              'Successful Resent',
              'Confirmation code has been resent, kindly check your email.',
              25,
              true
            );
          })
          .catch((error: any) => {
            NotificationUtility.error(
              'Issue Resending Email Confirmation Token',
              error.message ?? error,
              30,
              true
            );
          });
      }
    });
  };

  handleConfirmation = (e: React.FormEvent) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((errors, value) => {
      if (!errors) {
        this.emailConfirmationHandler
          .ConfirmRegistration(value.username, value.confirmationcode)
          .then(() => {
            this.props.history.push('/login');
            NotificationUtility.success(
              'Successfully Confirmed',
              'You have successfully confirmed your account.',
              10,
              true
            );
          })
          .catch((error: any) => {
            NotificationUtility.error('Issue Confirming Email', error.message || error, 30, true);
          });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <StyleEmailConfirmationForm

        {...InputLayout}
        className="emailconfirmation"
        layout="vertical"
        onSubmit={this.handleConfirmation}>
        <p style={{ marginTop: 10 }}>
          An email has been sent to your email, please enter the confirmation code provided along
          with your email.
        </p>
        <FormControl
          style={InputColLayout}
          getFieldDecorator={getFieldDecorator}
          rules={[
            ...ValidationUtility.getType('email', 'Please enter a valid email address'),
            ...ValidationUtility.getRequired('Please enter a valid email address'),
          ]}
          name="username"
          label="Email">
          <Input
            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,0.35)' }} />}
            size="default"
          />
        </FormControl>
        <FormControl
          getFieldDecorator={getFieldDecorator}
          rules={[{ required: true, message: 'Please enter confirmation code' }]}
          name="confirmationcode"
          label="Confirmation Code">
          <Input prefix={<Icon type="key" style={{ color: 'rgba(0,0,0,.35)' }} />} />
        </FormControl>
        <Row type="flex" justify="space-between" className="emailConfirmationBtn">
          <Col span={24}>
            <Button htmlType="submit" type="primary" size="default" className="confirmEmailBtn">
              Confirm Email Address
            </Button>
          </Col>
          <Col span={24}>
            <Tooltip title="You only need to enter the registration email address to resent confirmation code. Please note that any previous code would become invalid.">
              <Button type="default" size="default" onClick={this.handleResendCode} className="resendEmailBtn">
                Resend Email Confirmation <Icon type="question-circle" />
              </Button>
            </Tooltip>
          </Col>
          <Col span={24} className="loginLink">
            <br />
            <p>
              Already Registered? Sign in <NavLink to="/login">here</NavLink>
            </p>
          </Col>
        </Row>
      </StyleEmailConfirmationForm>
    );
  }
}

const EmailConfirmationFormWithoutRouter = Form.create<Props>({
  name: 'EmailConfirmationForm',
})(EmailConfirmationFormWithoutFormAndRouter);

const EmailConfirmationForm = withRouter(EmailConfirmationFormWithoutRouter);

export default EmailConfirmationForm;
